import axios from 'axios'
import {Message, MessageBox, Notification} from 'element-ui'
import {UserModule} from '@/store/modules/user'
import Cookies from 'js-cookie'

import _ from 'lodash'

const service = axios.create({
  //baseURL: '/',
  ///timeout: 5000
})

// Request interceptors
service.interceptors.request.use(
  (config) => {
    // Add X-Access-Token header to every request, you can add other custom headers here
    if (UserModule.token && (!config.params || !config.params.Token)&&!_.includes(config.url,'Token')) {
      config.headers['Authorization'] = UserModule.token
    }
    config.headers = { 'Authorization': Cookies.get('token') }
    
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

// Response interceptors
service.interceptors.response.use(
  (response) => {
    //console.log(response,3)
    let obj: any = {
      200: async () => {
        if(!response.data.Success){
          response.data.Content ? Notification.error({
            title: '',
            dangerouslyUseHTMLString: true,
            message: response.data.Content
          }) : '';
          return
        }
        response.data.content ? Notification.success({
          title: '',
          dangerouslyUseHTMLString: true,
          message: response.data.content
        }) : '';
      }
    }
    try {
      obj[response.status]();
    }catch (e) {

    }
    return Promise.resolve(response.data)
  },
  (error) => {
    let obj: any = {
      401: async () => {

      }
    }
    try {
      obj[error.response.status]();
    }catch (e) {

    }
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
